import { SupabaseClient } from '@supabase/supabase-js'
import { Row } from './supabase.interface'

export async function getNotifications(
  db: SupabaseClient,
  userId: string,
  limit: number
) {
  const { data } = await db
    .from('Notification')
    .select('*')
    .eq('user_id', userId)
    .is('deleted_at', null)
    .order('created_at', { ascending: false } as any)
    .limit(limit)
  return data?.map((d: Row<'Notification'>) => d)
}
